import { useFormikContext } from "formik";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { confirmTrialAtom, userInfoAtom } from "src/atoms";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { useRouter } from "src/hooks/useRouter";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

interface ISiteTypeOptionsProps {
  productKey: string; // 제품 키
  // priceType?: string;
  isRenew?: boolean;
  // handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}
const SiteTypeOptions = ({
  productKey,
  // priceType = "premium",
  isRenew = false,
}: // handleChange,
ISiteTypeOptionsProps) => {
  const [confirmTrial] = useRecoilState(confirmTrialAtom);
  const [searchParams, setSearchParams] = useSearchParams();
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { t } = useTranslation();
  const route = useRouter();
  const { setFieldValue, values, handleChange } = useFormikContext<any>();
  const { payTerm, priceType = "premium" } = values;
  const { isOciProduct } = useIsOciProduct();
  // const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   console.log("e", e.target.value);
  //   if (e.target.name === "siteType") {
  //     // setPriceType(e.target.value);
  //     if (e.target.value === "trial") {
  //       route.goSiteTrial();
  //     } else if (e.target.value === "promotion") {
  //       route.goSitePromotion({});
  //     } else if (e.target.value !== priceType) {
  //       // 기본 결제 주기 연간으로 선택
  //       route.goPay({ pay: "year", type: e.target.value });
  //     }
  //   }
  // };
  useEffect(() => {
    if (priceType) {
      if (priceType === "trial") {
        route.goSiteTrial();
      } else if (priceType === "promotion") {
        route.goSitePromotion({});
      } else {
        // 기본 결제 주기 연간으로 선택
        route.goPay({ pay: "year", type: priceType });
      }
    }
  }, [priceType]);
  return (
    <>
      <h4 className="form-title">
        {t("siteType." + priceType + ".orderSpecification.title")}
      </h4>
      <div className="form-item">
        <span className="form-item-title">
          {t("siteType." + priceType + ".orderSpecification.planType")}
        </span>
        {isOciProduct &&
        !searchParams.has("pay") &&
        !searchParams.has("type") ? (
          <span style={{ fontSize: "1rem" }}>
            {t(
              "siteType.subscriptionType." +
                productKey +
                ".subscriptionType_premium"
            )}
          </span>
        ) : (
          <Form.Select
            name="priceType"
            value={
              route.currentPath.includes("trial")
                ? "trial"
                : priceType === "premium"
                ? "promotion"
                : priceType
            }
            onChange={handleChange}
            className="form-control custom-form width w-370"
            disabled={isRenew || !isOciProduct}
          >
            {/* 
            에코 + 영문일때만 무료체험 옵션 보이게 한적있음
            {getProductFromSessionStorage() === "WRAPSODY_ECO" &&
            lang === "en" && (
              <option
                value="trial"
                // disabled={!confirmTrial}
              >
                {t(
                  "siteType.subscriptionType." +
                    productKey +
                    ".subscriptionType_free"
                )}
              </option>
            )} */}
            {getProductFromSessionStorage() === "WRAPSODY" && (
              <option
                value="drive"
                // disabled={!confirmDrive}
              >
                {t(
                  "siteType.subscriptionType." +
                    productKey +
                    ".subscriptionType_drive"
                )}
              </option>
            )}
            <option
              value="basic"
              // disabled={!confirmBasic}
            >
              {t(
                "siteType.subscriptionType." +
                  productKey +
                  ".subscriptionType_basic"
              )}
            </option>
            {/* {productKey === "wrapsody" && (
                      <option value="basicPlus" disabled={!confirmBasicPlus}>
                        {t(
                          "siteType.subscriptionType." +
                            productKey +
                            ".subscriptionType_basicPlus"
                        )}
                      </option>
                    )} */}
            <option
              value="plus"
              // disabled={!confirmPlus}
            >
              {t(
                "siteType.subscriptionType." +
                  productKey +
                  ".subscriptionType_plus"
              )}
            </option>

            {/* {productKey === "wrapsody" && (
                      <option value="plusPlus" disabled={!confirmPlusPlus}>
                        {t(
                          "siteType.subscriptionType." +
                            productKey +
                            ".subscriptionType_plusPlus"
                        )}
                      </option>
                    )} */}
            {!isOciProduct && (
              <option value="promotion">
                {t(
                  "siteType.subscriptionType." +
                    productKey +
                    ".subscriptionType_premium"
                )}
              </option>
            )}
          </Form.Select>
        )}
      </div>
    </>
  );
};
export default SiteTypeOptions;
